import { useContext } from "react";
import { I18nContext } from "react-i18next";
export default function useLocale() {
    var i18n = useContext(I18nContext).i18n;
    return i18n.language;
}
